import { Flex } from "@similarweb/ui-components/foundations";

import FormSelectCombobox from "app/pages/sales-intelligence/common-components/dropdown/FormSelectCombobox/FormSelectCombobox";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import type { AccountsExportBulkSelection } from "../../types";
import { BULK_CHOOSE } from "../../types";

const OPTIONS: readonly AccountsExportBulkSelection[] = [BULK_CHOOSE, "create-all-new", "create-or-update"];

const LABEL_KEY: Record<AccountsExportBulkSelection, string> = {
    [BULK_CHOOSE]: "si.advanced_search.accounts_export_preview_modal.bulk.choose",
    "create-all-new": "si.advanced_search.accounts_export_preview_modal.bulk.create_all_new",
    "create-or-update": "si.advanced_search.accounts_export_preview_modal.bulk.create_or_update",
};

type AccountsExportBulkActionsProps = {
    value: AccountsExportBulkSelection;
    onChange(value: AccountsExportBulkSelection): void;
};

export const AccountsExportBulkActions = ({ value, onChange }: AccountsExportBulkActionsProps) => {
    const translate = useTranslation();

    return (
        <Flex inline alignItems="center" data-automation="accounts-export-bulk-actions">
            <FormSelectCombobox<AccountsExportBulkSelection>
                fieldName="accounts-export-bulk"
                value={value}
                options={OPTIONS}
                width={250}
                onChange={onChange}
                formatValue={(option) => translate(LABEL_KEY[option])}
            />
        </Flex>
    );
};
